<template>
    <router-view v-slot="{ Component }">
        <transition name="page">
            <component :is="Component" />
        </transition>
    </router-view>
</template>

<script setup lang="ts">
defineOptions({
    name: 'Documents'
})
</script>
